module.exports = __webpack_public_path__ + "static/media/educazione-finanziaria_investimento.7bbcccff.png";